//考试用工具
import Vue from 'vue'
import { getQiniuUrl } from '@/utils/qiniu.js'
import { getAction, postAction } from '@/api/manage'
import { ACCESS_TOKEN} from "@/store/mutation-types"

export const examMixins = {
  data() {
    return {
      paperId: '',
      paperInfo: {}, //试卷信息
      paperAnswer: [], // 答题卡信息
      currentQuestionIndex: 0, //当前显示的题目
      editorVisible: false,
      editorUrl: '',
      currentQuestionInfo: {}, //当前正在做的题目信息
      codingUrl: { //扣叮编辑器调用地址
        create: "https://coding.qq.com/creative-lab/?aice_headerless=1&partner=aice&aice_project_url=",
        python: "https://coding.qq.com/python-lab/?aice_headerless=1&partner=aice&aice_project_url="
      },
      isFullscreen: false, //是否全屏
    }
  },
  methods: {
    getQiniuUrl: getQiniuUrl,
    //打开编辑器
    openEditor(questionInfo) {
      this.editorVisible = true
      this.editorUrl = this.getEditorUrl(questionInfo)
    },
    getCode(){
      getAction("/thirdLogin/getCode", {token: Vue.ls.get(ACCESS_TOKEN)}).then(res=>{
        let code = res.result
        window.open(`https://test.coding.qq.com/login_proxy/partners_proxy.html?platform=aice_test&code=${code}&redirect_uri=https%3A%2F%2Ftest.coding.qq.com%2F`)
      })
    },
    //获取编辑器地址
    getEditorUrl(questionInfo) {
      this.currentQuestionInfo = questionInfo
      let url
      switch (questionInfo.codeType) {
        case 1:
          url = '/scratch3/index.html?v=2'
          break
        case 2:
          url = '/scratch3/index.html?v=3'
          break
        case 3:
          url = '/scratchjr/editor.html?mode=edit'
          break
        case 4:
          url = '/onlinecode/index.html?lang=turtle'
          break
        case 5:
          url = '/onlinecode/index.html?lang=python'
          break
        case 6:
          url = '/onlinecode/index.html?lang=c'
          break
        case 7:
          url = '/onlinecode/index.html?lang=cpp'
          break
        case 8:
          url = '/onlinecode/index.html?lang=java'
          break
        case 11: //打开扣叮图形化编辑器
          let fileUrl = ""
          if (questionInfo.myAnswerFile) {
            fileUrl = this.getQiniuUrl(questionInfo.myAnswerFile)
            if(fileUrl.startsWith("http")){
              fileUrl=fileUrl.replace("http:", "https:")
            }else if(fileUrl.startsWith("//")){
              fileUrl="https:"+fileUrl
            }
          }else if(questionInfo.questionStemFile){
            fileUrl = questionInfo.questionStemFile.replace("http:", "https:")
          }
          fileUrl+="?attname="
          url = this.codingUrl.create + encodeURIComponent(fileUrl)
          return url
        case 12: //打开扣叮Python编辑器
          let pyFileUrl = ""
          if (questionInfo.myAnswerFile) {
            pyFileUrl = this.getQiniuUrl(questionInfo.myAnswerFile)
            if(pyFileUrl.startsWith("http")){
              pyFileUrl=pyFileUrl.replace("http:", "https:")
            }else if(pyFileUrl.startsWith("//")){
              pyFileUrl="https:"+pyFileUrl
            }
          }else if(questionInfo.questionStemFile){
            pyFileUrl = questionInfo.questionStemFile.replace("http:", "https:")
          }
          pyFileUrl+="?attname="
          url = this.codingUrl.python + encodeURIComponent(pyFileUrl)
          return url
      }
      
      url += '&scene=exam&questionId=' + (questionInfo.questionId || questionInfo.id)
          + '&paperId=' + questionInfo.paperId 
          + "&userPaperId=" + this.userPaperId 
          + "&departId=" + this.departId
          + "&workName=" + this.$t('exam.exam')
      if (questionInfo.myAnswerFile) {
        url += "&workId=" + questionInfo.myAnswerFile
      }
      if(questionInfo.isSubmit && questionInfo.answerId){//修改oc程序传入answerId
        url += "&answerId=" + questionInfo.answerId
      }
      return url
    },
    //渲染填空题
    renderGapFillingStemDom(question, index) {
      if (question.questionType != 4) {
        return
      }
      let that = this
      let stem = question.questionStem
      //替换下划线为input组件
      let reg = /(_)\1{2,}/g
      let gaps = stem.match(reg)
      for (let i = 0; i < gaps.length; i++) {
        let gap = gaps[i]
        stem = stem.replace(
          gap,
          `<a-input
          style="display:inline;border-radius:0;border:none;border-bottom:solid 1px;width:${gap.length * 7}px"
          v-model="value[${i}]"
        />`
        )
      }
      stem = "<div>"+stem+"</div>"
      //定义组件
      let FillillStemCompnent = Vue.extend({
        template: stem,
        data: function () {
          return {}
        },
        props: {
          value: {
            type: Array,
          },
        },
        created: function () {},
      })
      //挂载组件
      this.$nextTick(()=>{
        new FillillStemCompnent({propsData: {
            value: (that.paperAnswer&&that.paperAnswer.length>0&&that.paperAnswer[index])?that.paperAnswer[index]['myAnswer']:[]
          }
          }).$mount('#question-stem-' + question.id)
      })
    },
    //索引转大写字母
    index2letter(index) {
      if (index < 0 || index > 25) {
        return ''
      }
      return String.fromCharCode(65 + index)
    },
    //格式化时间
    formatTime(time) {
      var minutes = Math.floor(time / 60)
      var seconds = Math.floor(time % 60)
      return minutes + ':' + seconds
    },
    //跳转到题目
    jumpQuestion(i) {
      if(this.userPaperInfo && this.userPaperInfo.paperStyle == 2){
        this.currentQuestionIndex = i
      }else{
        this.$el.querySelector('#q-' + i).scrollIntoView({ block: 'start', behavior: 'smooth' })
      }
    },
    //解析答题信息
    parseAnswer(type, answer) {
      if (answer == "") {return ""}
      if (type == 1 || type == 2 || type == 4) {
        let myAnswer = JSON.parse(answer)
        return myAnswer
      } else {
        return answer
      }
    },
    //答案转字符
    answer2Text(question) {
      if (question['questionAnswer'] == null) {
        return this.$t('sys.noData')
      }
      let that = this
      let gapWhich = this.$t('exam.gapWhich')
      let gapAnswer = this.$t('exam.gapAnswer')
      let gapOr = this.$t('exam.gapOr')
      if(question['questionAnswer'] == null){
        return null
      }
      switch (question.questionType) {
        case 1:
          return this.index2letter(parseInt(question['questionAnswer']))
        case 2:
          return JSON.parse(question['questionAnswer'])
            .map((a) => {
              return that.index2letter(parseInt(a))
            })
            .join(' ')
        case 3:
          return question['questionAnswer'] === 'true' ? this.$t('exam.right') : this.$t('exam.wrong')
        case 4:
          return JSON.parse(question['questionAnswer'])
            .map((a, i) => {
              if(a['item']){
                return gapWhich + (i + 1) + gapAnswer + a['item'].join(gapOr)
              }else{
                return ''
              }
            })
            .join('】，') + '】'
        case 5:
          return this.$t('exam.keywords') + JSON.parse(question['questionAnswer']).join('，')
        default:
          return question['questionAnswer']
      }
    },
    //是否已批改
    isReviewAnswer(i) {
      if(this.paperAnswer[i]['gotScore'] === undefined || this.paperAnswer[i]['gotScore'] === null){
        return false
      }else{
        return true
      }
    },
    //是否已作答
    isWriteAnswer(i) {
      if (this.paperAnswer[i] == undefined || this.paperAnswer[i]['myAnswer'] == null) {
        return false
      }
      if ('myAnswerFile' in this.paperAnswer[i] && this.paperAnswer[i]['myAnswerFile']) {
        return true
      }
      if (typeof this.paperAnswer[i]['myAnswer'] == 'string' && this.paperAnswer[i]['myAnswer'] != '') {
        return true
      } else if (typeof this.paperAnswer[i]['myAnswer'] == 'number' && this.paperAnswer[i]['myAnswer'] != null) {
        return true
      } else if (typeof this.paperAnswer[i]['myAnswer'] == 'object' && this.paperAnswer[i]['myAnswer'].length > 0) {
        return true
      }
      return false
    },
    getQuestionTypeText(questionType){
      switch(questionType){
        case 1: return '单选题'
        case 2: return '多选题'
        case 3: return '判断题'
        case 4: return '填空题'
        case 5: return '主观题'
        case 6: return '阅读分析'
        case 7: return '编程题'
        case 8: return 'OJ题'
      }
    },
    //请求读题文本
    getQuestionVoice(question){
      if(question.voiceText != null && question.voiceText != ''){
        return question.voiceText;
      }
      let options = question.questionOptions
      let text = question.questionStem
      if(question.questionType == 1 || question.questionType == 2){
        //单选多选
        for(let i=0;i<options.length;i++){
          text += "\n\n"
          text += this.index2letter(i)
          text += "\n\n"
          text += options[i].item
        }
      }else if(question.questionType == 3){
        //判断题
        text += "\n\nA 正确\n\nB 错误"
      }else if(question.questionType == 4){
        //填空题，空位停顿
        text = text.replaceAll('_',' ')
      }
      return text
    },
    // 提示
    notify(text){
      this.$notification.open({
        message: this.$t('sys.notice'),
        description: text
      });
    },
    //全屏
    fullScreen() {
      let element = document.documentElement;
      let requestMethod = element.requestFullScreen || //W3C
        element.webkitRequestFullScreen || //Chrome
        element.mozRequestFullScreen || //FireFox
        element.msRequestFullScreen; //IE11
      if (requestMethod) {
        requestMethod.call(element);
      } else if (typeof window.ActiveXObject !== "undefined") { //for Internet Explorer
        let wscript = new ActiveXObject("WScript.Shell");
        if (wscript !== null) {
          wscript.SendKeys("{F11}");
        }
      }
      this.isFullscreen = true

      //考试隐藏53kf
      this.hide53kf()
    },
    //退出全屏
    exitFullscreen() {
      if (window.document.exitFullscreen) {
        window.document.exitFullscreen()
      } else if (document.mozCancelFullScreen) {
        window.document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) {
        window.document.webkitExitFullscreen()
      }
      this.isFullscreen = false
      setTimeout(function(){
        //窗口会失去焦点，需要清楚一次记录
        window.onfocus()
      }, 1000)
    },
    //检查chrome版本
    checkChromeVersion(){
      if(navigator.userAgent.indexOf('Wechat') > -1){
        alert("请不要在微信内打开本页面")
        return false;
      }
      var arr = navigator.userAgent.split(' '); 
      var chromeVersion = '';
      for(var i=0;i < arr.length;i++){if(/chrome/i.test(arr[i]))chromeVersion = arr[i]}
      if(chromeVersion){return Number(chromeVersion.split('/')[1].split('.')[0]);} 
      else {return false;}
    },
    changeURLStatic(name, value) {
      var url = location.href;
      var reg = eval('/([\?|&]'+name+'=)[^&]*/gi');
      value = value.toString().replace(/(^\s*)|(\s*$)/g,"");  //移除首尾空格
      if(!value){
          var url2 = url.replace(reg , '');  //正则替换
      }else{
          if(url.match(reg)){
              var url2 = url.replace(reg , '$1' + value);  //正则替换
          }else{
              var url2 = url + (url.indexOf('?') > -1 ? '&' : '?') + name + '=' +value;  //没有参数添加参数
          }
      }
      history.replaceState(null,null, url2);  //替换地址栏
    },
    hide53kf(){
      let kfdom = document.getElementById("icon_module")
      if(kfdom){
        kfdom.style.display = "none"
      }
    },
    show53kf(){
      let kfdom = document.getElementById("icon_module")
      if(kfdom){
        kfdom.style.display = "block"
      }
    },
  }
}

